
<div class="row">
    <div class="col-12">
  
        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'История выгрузки товаров' | translate }}</div>
                <div class="tools">
                </div>
            </div>
            <div class="card-body table-block">

                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="name">{{ 'PRODUCT.TYPE_OF_UNLOADING' | translate }}</th>
                            <th scope="col" class="name">{{ 'DATE' | translate }}</th>
                            <th scope="col" class="name"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="orgHistory.length > 0">
                        <tr *ngFor="let item of orgHistory">
                            
                            <td class="products">{{ changeName(item.common_settings.type) }}</td>
                            <td class="products">{{ item.name | date: 'dd.MM.yyyy HH:mm' }}</td>
                            
                            <td class="action">
                                <div class="action-btn">
                                    <button type="button" class="btn btn-none btn-download"  placement="top" ngbTooltip="{{ 'PRODUCT.REPEAT_UPLOAD' | translate }}" (click)="onDownload(item)" tooltipClass="clue-name" [closeDelay]="300">
                                        <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':20,'height.px':20}"></svg-icon>
                                    </button>
                                    <button style="margin-left: 5px;" type="button" class="btn btn-none btn-download" placement="top" ngbTooltip="{{ 'PRODUCT.APPLY_SETTING_FROM_UPLOAD_TO_SELECTED_PRODUCTS' | translate }}" tooltipClass="clue-name" [closeDelay]="300" (click)="onEditDownload(item)">
                                        <svg-icon class="" src="/assets/images/icons/loop.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="orgHistory.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="3">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="3">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

    </div>
</div>